"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEmailAt(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8.00081 10.052a1.92656 1.92656 0 0 1 -1.77747-1.26675 2.1502 2.1502 0 0 1 .41614-2.23539 1.83715 1.83715 0 0 1 2.097-.44466 2.05633 2.05633 0 0 1 1.18661 1.895 1.99107 1.99107 0 0 1 -1.92228 2.0518zm0 5.948h.22852a.957.957 0 0 0 0-1.91h-.22852a5.53323 5.53323 0 0 1 -4.03781-1.78478 6.37786 6.37786 0 0 1 0-8.61164 5.46008 5.46008 0 0 1 8.07316 0 6.30294 6.30294 0 0 1 1.67346 4.30627v1.63115a.99735.99735 0 1 1 -1.99469 0v-1.63115a3.93567 3.93567 0 0 0 -2.869-3.893 3.65767 3.65767 0 0 0 -4.1996 2.113 4.15338 4.15338 0 0 0 .9934 4.83623 3.54468 3.54468 0 0 0 4.64223.04931 2.72058 2.72058 0 0 0 3.1459 1.42218 2.94946 2.94946 0 0 0 2.072-2.89658v-1.63094a8.28524 8.28524 0 0 0 -2.19511-5.65734 7.27636 7.27636 0 0 0 -5.30394-2.34271 7.27985 7.27985 0 0 0 -5.3056 2.34271 8.2839 8.2839 0 0 0 -2.19521 5.65734 8.27775 8.27775 0 0 0 2.19521 5.65574 7.27567 7.27567 0 0 0 5.3056 2.34421z' })));
}
exports.default = SvgEmailAt;
